import {Component, inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import {Router, RouterLink} from "@angular/router";
import {Store} from "@ngrx/store";
import {loadDashboardStatistics, loadRecentActivity} from "../../state/dashboard.actions";
import {selectDashboardStatistics, selectRecentActivity} from "../../state/dashboard.selectors";
import {BsBuildKitIconComponent} from "../../../shared/icons/bs-build-kit-icon.component";
import {BsCadIconComponent} from "../../../shared/icons/bs-cad-icon.component";
import {BsDrawingIconComponent} from "../../../shared/icons/bs-drawing-icon.component";
import {BsProjectIconComponent} from "../../../shared/icons/bs-project-icon.component";
import {TimeFromNowPipe} from "../../../shared/pipes/time-from-now.pipe";
import {map} from "rxjs/operators";
import {AuthService} from "../../../shared/service/auth.service";
import {toSignal} from "@angular/core/rxjs-interop";
import {Divider} from "primeng/divider";
import {Tooltip} from "primeng/tooltip";
import {RecentlyCreatedOrModifiedItems} from "../../../shared/models/dashboard.model";
import {BsReportIconComponent} from "../../../shared/icons/bs-report-icon.component";
import {Chip} from "primeng/chip";
import {FormsModule} from "@angular/forms";
import {SelectButton, SelectButtonChangeEvent} from "primeng/selectbutton";
import {BsUserManagementIconComponent} from "../../../shared/icons/bs-material-weight-icon.component";


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, RippleModule, RouterLink, BsBuildKitIconComponent, BsCadIconComponent, BsDrawingIconComponent, BsProjectIconComponent, TimeFromNowPipe, Divider, Tooltip, BsReportIconComponent, Chip, FormsModule, SelectButton, BsUserManagementIconComponent]
})
export class DashboardComponent implements OnInit {
  store = inject(Store);
  bsAuthService = inject(AuthService);
  router = inject(Router);

  themeCard = {
    bodyPadding: 0,
    background: 'var(--p-bs-dashboard-statistics-background)'
  }
  buildKitStatisticFilterItems: any[] = [
    { name: 'All', value: 0, hintText: 'Estimates for all Build Kits' },
    { name: 'Active', value: 1, hintText: 'Estimates for active Build Kits' },
    { name: 'Month', value: 2, hintText: 'Estimates for Build Kits created in last month' },
    { name: 'Week', value: 3, hintText: 'Estimates for Build Kits created in last week' },
  ];
  selectedBuildKitStatisticItem = 0;
  recentActivity = this.store.selectSignal(selectRecentActivity);
  dashboardStatistics = this.store.selectSignal(selectDashboardStatistics);
  usersName = toSignal(this.bsAuthService.customerClaimReplay
    .pipe(
      map((claims: any) => claims?.name ?? '')
    ));

  ngOnInit(): void {
    console.log('DashboardComponent ngOnInit');
    this.store.dispatch(loadRecentActivity());
    this.store.dispatch(loadDashboardStatistics({ filterItem: this.selectedBuildKitStatisticItem }));
  }

  onBuildKitStatisticFilterChange(event: SelectButtonChangeEvent){
    this.store.dispatch(loadDashboardStatistics({ filterItem: event.value }));
  }

  itemClicked(item: RecentlyCreatedOrModifiedItems){
    if(item){
      let route = '';
      switch(item.searchType) {
        case 'Projects':
          this.router.navigate(['projects'], { queryParams: { globalSearch: item.id} });
          break;
        case 'CadModels':
          this.router.navigate([`cad-data/${item.id}`], { queryParams: { revision: item.idTwo} });
          break;
        case 'Drawings':
          if(item.idTwo && item.idThree){
            this.router.navigate([`cad-data/${item.idTwo}`], { queryParams: { revision: item.idThree, drawing: item.id} });
          } else {
            this.router.navigate(['drawing'], { queryParams: { globalSearch: item.id} });
          }
          break;
        case 'BuildKits':
          this.router.navigate([`build-kit/${item.id}/cad-data`]);
          break;
        case 'Reports':
          route = ''
          break;
        case 'Library':
          route = ''
          break;
      }
    }
  }
}
